import { NgModule } from '@angular/core';
import { BaseModule } from '../../base.module';
import { RouterModule } from '@angular/router';
import { MATERIALS } from '../../../app.materials';
import { SharedPopoverModule } from '../../popover/popover.module';
import { EditModalHeaderActionComponent } from './edit-modal-header-action.component';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        RouterModule,
        SharedPopoverModule,
    ],
    exports: [
        EditModalHeaderActionComponent
    ],
    declarations: [
        EditModalHeaderActionComponent
    ]
})
export class EditModalHeaderActionModule { }
